// extracted by mini-css-extract-plugin
export default {"basice_layout_box":"index_basice_layout_box__3nzQk","layout_content":"index_layout_content__S5W9W","content_box":"index_content_box__MTEa+"};